import React from 'react';

import { Auth,I18n } from 'aws-amplify';
import {
  AuthPiece,
  FormSection,
  SectionHeader,
  SectionBody,
  SectionFooter,
  ButtonRow,
} from 'aws-amplify-react';

import LogoArea from './logoarea.js';
import Stepper from './stepper.js';
import LapDialog from '../util/laplaceDialog.js';

export default class Confirmation extends AuthPiece {
  constructor (props) {
    super(props);
    this.state = {
      open: false
    };
    this._validAuthStates = ['confirmation'];
  }
  post = () => {
    const {authData, param} = this.props.authData;
    param["custom:organization"] = param["custom:organization"]=== undefined ? "" : param["custom:organization"];
    param["custom:furigana_org"] = param["custom:furigana_org"]=== undefined ? "" : param["custom:furigana_org"];
    
    Auth.updateUserAttributes(authData.user, param).then((result) => {
      Auth.signIn(authData.userData.username, authData.userData.pw).then((user) => {
        localStorage.removeItem('USER_PROFILE');
        this.changeState('signedIn', user);
      }).catch((err) => {
        console.log('signIn err');
        console.log(err);
        this.setState({
          open: true
        });
      });
    }).catch(err => {
      console.log('updateUserAttr');
      console.log(err);
      this.setState({
        open: true
      });
    });
  }
  toClose = () => {
    this.setState({
      open: false
    });
  }
  toSignin = () => {
    this.changeState('signIn');
  }
  toBack = () => {
    const datum = {
      user: this.props.authData.authData.user,
      userData: this.props.authData.authData.userData,
    };
    this.props.authData.setter();
    this.changeState('secondSignUp', datum);
  }
  checkLocaleWithName = () => {
    if (window.LAPLACEID_LOCALE === 'ja') {
      return(
      <div className="loginInputFlex">
        <div>
          <label className="loginLabel">{I18n.get('Last name furigana')}</label>
          <p>{this.props.authData.param['custom:furigana_family']}</p>
        </div>
        <div>
          <label className="loginLabel">{I18n.get('First name furigana')}</label>
          <p>{this.props.authData.param['custom:furigana_given']}</p>
        </div>
      </div>
      );
    } else {
      return;
    }
  }
  checkLocaleWithOrg = () => {
    if (window.LAPLACEID_LOCALE === 'ja') {
      return(
        <div>
          <label className="loginLabel">{I18n.get('organization furigana')}</label>
          <p>{this.props.authData.param['custom:furigana_org']}</p>
        </div>
      );
    } else {
      return;
    }
  }
  showComponent(theme) {
    const datum = {
      user: this.props.authData.authData.user,
      userData: this.props.authData.authData.userData,
    };
    return (
      <div className="loginContainer">
        <LogoArea theme={theme} />
        <FormSection theme={theme}>
          <SectionHeader theme={theme}>{I18n.get('Confirm your profile')}</SectionHeader>
          <Stepper nowStatus="100%" />
          <SectionBody theme={theme}>
            <div className="loginConfirmation">
              <label className="loginLabel">{I18n.get('Mail')}</label>
              <p>{datum.user.signInUserSession.idToken.payload.email}</p>
              <div className="loginInputFlex">
                <div>
                  <label className="loginLabel">{I18n.get('Last name')}</label>
                  <p>{this.props.authData.param['family_name']}</p>
                </div>
                <div>
                  <label className="loginLabel">{I18n.get('First name')}</label>
                  <p>{this.props.authData.param['given_name']}</p>
                </div>
              </div>
              {this.checkLocaleWithName(theme)}
              <label className="loginLabel">{I18n.get('Company/Institution name')}</label>
              <p>{this.props.authData.param['custom:organization']}</p>
              {this.checkLocaleWithOrg(theme)}
              <div className="loginButtonFlex">
                <ButtonRow style={theme.loginHalfButton} onClick={this.toBack} theme={theme}>
                  {I18n.get('Back')}
                </ButtonRow>
                <ButtonRow style={theme.loginHalfButton} onClick={this.post} theme={theme}>
                  {I18n.get('Enter')}
                </ButtonRow>
              </div>
            </div>
            <p>{this.state.signUpError}</p>
          </SectionBody>
          <SectionFooter theme={theme}>
          </SectionFooter>
        </FormSection>
        <LapDialog contentText={I18n.get('Your session is expired. Please re-login.')} open={this.state.open} toClose={this.toClose} onExit={this.toSignin} />
      </div>
    );
  }
}
